<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="shrink-0"
    :class="$attrs.class"
  >
    <rect x="2" y="5" width="9" height="14" rx="2" />
    <rect x="13" y="5" width="9" height="14" rx="2" />
    <path d="M6 9h1M6 12h1M6 15h1" stroke-width="1.5" />
    <path d="M17 9h1M17 12h1M17 15h1" stroke-width="1.5" />
  </svg>
</template>

<script setup>
defineOptions({ inheritAttrs: false });
</script>
